<div class="topMenu py-2 d-none d-sm-none d-md-block shadow bg-body rounded">
    <div id="mas_garantia"class="topMenuBanner" style="width: 250px;margin-left:5%;">
      <img src="../../../assets/img/LogotipoMasGarantia.svg"/>
    </div>
  
    <div class="topMenuItemContainer">
      <div><a class="textToolBar text-muted"> {{ 'INFO_TOOLBAR.LABEL1' | translate }} </a></div>
      <div>
        <div class="popover__wrapper d-none d-sm-none d-md-block">
          <a href="#" style="font-size:14px;font-weight:normal;cursor:pointer;text-decoration: none;" class="text-muted">
            {{ 'INFO_TOOLBAR.LABEL2' | translate }} <fa-icon [icon]="faAngleDown" class="fa-solid fa-angle-down"></fa-icon>
          </a>
          <div class="popover__content">
            <div class='container-fluid'>
              <div class='row'>
                <div class="col-12">
                  <span><a class='text-decoration-none text-muted '
                      href='https://miseguro.liverpool.com.mx/proteccion-integral-familiar'> {{ 'INFO_TOOLBAR.LABEL3' | translate }} </a></span>
                </div>
                <div class="col-12">
                  <a class='text-decoration-none text-muted mt-1' href='https://miseguro.liverpool.com.mx/seguro-de-auto'> {{ 'INFO_TOOLBAR.LABEL4' | translate }} </a>
                </div>
                <div class="col-12">
                  <a class='text-decoration-none text-muted mt-1'
                    href='https://miseguro.liverpool.com.mx/proteccion-celular'> {{ 'INFO_TOOLBAR.LABEL5' | translate }} </a>
                </div>
                <div class="col-12">
                  <a class='text-decoration-none text-muted mt-1' href='https://masgarantia.liverpool.com.mx/'> {{ 'INFO_TOOLBAR.LABEL6' | translate }} </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div><a class="textToolBar text-muted" href="https://miseguro.liverpool.com.mx/mis-polizas"> {{ 'INFO_TOOLBAR.LABEL7' | translate }} </a></div>
    </div>
  </div>